'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Easing = undefined;
exports.scrollWithAnimation = scrollWithAnimation;

var _tween = require('@tweenjs/tween.js');

var _tween2 = _interopRequireDefault(_tween);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestAnimationFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };
}();

function animate() {
  if (_tween2.default.update()) {
    requestAnimationFrame(animate);
  }
}

requestAnimationFrame(animate);

var Easing = exports.Easing = _tween2.default.Easing;

function scrollWithAnimation(scrollEl, current, target, time, easing) {
  new _tween2.default.Tween({ postion: current }).to({ postion: target }, time).easing(easing).onUpdate(function (val) {
    scrollEl.scrollTop = val.postion;
  }).start();

  animate();
}